import { FC } from 'react'
import { BetaTagWrapper } from './betaTag.styles'

interface Props {
  isActive?: boolean
}

const BetaTag: FC<Props> = ({ isActive }) => (
  <BetaTagWrapper isactive={isActive ? 'true' : 'false'}>Beta</BetaTagWrapper>
)

export default BetaTag
